// The Main Site Object
window.Site = {

    headerButton     : document.querySelector('.header-button-about'),
    backButton       : document.querySelector('.header-back'),
    aboutSection     : document.querySelector('#about'),
    projectsOriginal : document.querySelector('.selected-projects,.regesto-list'),
    cursor           : document.querySelector('.cursor'),

    // Init Function
    liftoff : () => {
        Site.toggleAbout()
        Site.closeMobileSection()
        Site.animateCursor()

    },

    toggleAbout : () => {

        if (!Site.headerButton) return;

        Site.headerButton.addEventListener('click' , () => {

            // Toggle the mobile menu
            if (window.matchMedia('(width < 800px)').matches) {
                document.documentElement.classList.toggle('mobile-navigation-is-open');
                document.documentElement.classList.remove('about-is-open');
                document.documentElement.classList.remove('contact-is-open');
            } else {
                document.documentElement.classList.remove('mobile-navigation-is-open');
                document.documentElement.classList.toggle('about-is-open');
            }

        })
    },

    toggleMobileAbout   : () => { document.documentElement.classList.add('about-is-open') },
    toggleMobileContact : () => { document.documentElement.classList.add('contact-is-open') },

    closeMobileSection : () => {
        if (!Site.backButton) return;
        Site.backButton.addEventListener('click' , () => {
            document.documentElement.classList.remove('about-is-open' , 'contact-is-open')
        })
    },

    // Filters function used in the regesto and the selected works page
    filterProjectsOnClick : () => {

        // Store the original content 
        let originalOrder = Site.projectsOriginal.innerHTML;

        document.querySelectorAll('.filters-input').forEach(input => {

            input.addEventListener('change' , event => {
                
                // Add the hidden class on all elements and remove the first-selected class when present
                document.querySelectorAll('.all').forEach(item => {
                    item.classList.add('hidden')
                    item.classList.remove('first-selected')
                })

                // Loop remove the hidden class on the items that are visible
                document.querySelectorAll(`.${input.value}`).forEach(item => {
                    item.classList.remove('hidden')
                })

                // Check how many items are hidden. If there are none we need to replace everything in it's original state
                if (document.querySelector('.hidden')) {
                    let visibleElements = document.querySelectorAll('.selected-project:not(.hidden)');
                    Site.projectsOriginal.prepend(...visibleElements)
                    document.querySelector(`.${input.value}`).classList.add('first-selected')

                } else {
                    Site.projectsOriginal.innerHTML = originalOrder;
                }

                // Grab the first visible item and add the first-selected class
                //document.querySelector(`.${input.value}`).classList.add('first-selected')






            })

        })

    },

    // Custom cursor
    animateCursor : () => {

        // We need to store the current cursor class
        let currentClass = "cursor-up";
        let nextClass    = null;

        let cursorX = null;
        let cursorY = null;

        window.addEventListener('mousemove' , event => {

            cursorX = event.clientY;
            cursorY = event.clientX;

            // Set the link style
            if (event.target.classList.contains('slider-prev')) {
                if (!Site.cursor.classList.contains('cursor-left')) {
                    Site.cursor.classList.toggle(currentClass)
                    Site.cursor.classList.toggle('cursor-left')
                    currentClass = 'cursor-left';
                };
            } else if (event.target.classList.contains('slider-next')) {
                if (!Site.cursor.classList.contains('cursor-right')) {
                    Site.cursor.classList.toggle(currentClass)
                    Site.cursor.classList.toggle('cursor-right')
                    currentClass = 'cursor-right';
                };
            } else if (event.target.tagName == "A" || event.target.tagName == "BUTTON" || event.target.tagName == "LABEL" ) {
                
                if (!Site.cursor.classList.contains('cursor-link')) {
                    Site.cursor.classList.toggle(currentClass)
                    Site.cursor.classList.toggle('cursor-link')
                    currentClass = 'cursor-link';

                };

                cursorY = cursorY - 9;
                cursorX = cursorX - 9;
                
            } else {
                Site.cursor.classList.toggle(currentClass)
                Site.cursor.classList.toggle('cursor-up')
                currentClass = 'cursor-up';

                cursorY = cursorY - 5;
                cursorX = cursorX - 5;

            }

            Site.cursor.style.top  = `${cursorX}px`;
            Site.cursor.style.left = `${cursorY}px`;

        })

    }

}

// Launch The Script
Site.liftoff()